module.exports = require("crypto-js");